module.exports = __webpack_public_path__ + "static/media/universal-access.1d0217c5.svg";